export const ADD_TO_CART_GUEST = "ADD_TO_CART_GUEST";
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";
export const CHANGE_QTY = "CHANGE_QTY";
export const OBTENCIONDELADB = "OBTENCION_BASE_DE_DATOS";
export const CAMBIOCANTIDAD = "DE_MENOR_A_MAYOR_EL_OBJETO_DEL_CARRITO";
export const REMOVIDODELADB = "OBJETO_REMOVIDO_DEL_ARRAY_DE_CARRITO";
export const ANIADIRALCARRO = "ANIADIR_ITEMS_AL_CARRO_DESDE_LA_TIENDA";
export const REMOVERDELCARROCERRARSESION = "REMOVER_DEL_CARRO_AL_CERRARSESION";
export const REMOVEALLITEMSFROMCARTITEMS = "REMOVEALLITEMSFROMCARTITEMS";
export const DATOSDEFACTURA = "DATOSDEFACTURA";
export const BORRADOCARRITOUSUARIO= "BORRADOCARRITOUSUARIO"
